<template>
  <div>
    <tag-manager resourceType="record" :resource='record' @reload-list="success" />

    <div class="tag-dropdown-column">
      <div class="existing-tags-wrapper" :class="tag.color" v-for="tag in record.tags">
        <div class="btn-group btn-group-toggle" data-toggle="buttons">
          <label class="btn active">
            <router-link :to="{name: 'tag', params: { id: tag.id }}">
              {{tag.name}}
            </router-link>
          </label>

          <label class="btn" @click.prevent="removeConnectedTag(tag)">
            <i class="fa fa-remove"></i>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _tag_manager from "./_tags_manager"

  export default {
    components: {
      'tag-manager': _tag_manager
    },
    props: ['record'],
    methods: {
      success() {
        this.$emit('success')
      },
      removeConnectedTag(tag) {
        this.store.removeConnectedTag(tag.id, { record_id: this.$props.record.id }).then(() => {
          this.store.sendMetrics({name: 'remove_tag_from_file', params: this.$route.params, path: this.$route.fullPath})
          this.success()
        })
      },
    }
  }
</script>
